import { useCallback } from "react";

import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { Skeleton } from "@mui/material";
import { Download } from "@mui/icons-material";

import { Toast } from "@covertree/utils";
import { DocumentItem } from "@covertree/ui/content/DocumentItem";

import { RenewalDetailsContentProps } from "@routing/routes/Renewals/RenewalDetails/RenewalDetailsContent/ContentTabs/types";
import { useGetRenewalLazyQuery } from "@covertree/agent-portal-graphql";
import { AGENT_HELP_ADDRESS } from "@consts/index";

export function Documents({ renewal, loading }: RenewalDetailsContentProps) {
  const [getRenewal, { loading: isRenewalRefreshing }] =
    useGetRenewalLazyQuery();

  const onOfferDocumentDownload = useCallback(async () => {
    if (!renewal?.offerDocument) {
      return null;
    }

    if (
      parseInt(renewal.offerDocument.urlExpirationTimestamp) >=
      Date.now() - 2000
    ) {
      window.open(renewal.offerDocument.url, "_blank");
    } else {
      Toast.showInfo("Refreshing documents");

      await getRenewal({
        fetchPolicy: "cache-and-network",
        variables: { renewalLocator: renewal.renewalLocator },
        onCompleted: (data) => {
          if (!data || !data.getRenewal.offerDocument) {
            Toast.showError("Couldn't refresh documents");
            return;
          }

          window.open(data.getRenewal.offerDocument.url, "_blank");
        },
      });
    }
  }, [renewal]);

  if (!renewal && loading) {
    return <Skeleton height={114} variant="rounded" />;
  }

  if (renewal && !renewal.offerDocument) {
    return (
      <Box>
        <Typography variant="subtitle1" color="black" textAlign="center">
          Renewal was found but it has no documents assigned. Please contact us
          via email at{" "}
          <Link color="secondary" href={`mailto:${AGENT_HELP_ADDRESS}`}>
            {AGENT_HELP_ADDRESS}
          </Link>
          .
        </Typography>
      </Box>
    );
  }

  if (renewal?.offerDocument) {
    return (
      <DocumentItem
        name={renewal.offerDocument.displayName}
        actions={[
          {
            onClick: onOfferDocumentDownload,
            isLoading: isRenewalRefreshing,
            name: "Download",
            icon: <Download />,
          },
        ]}
      />
    );
  }
}
